/*eslint no-use-before-define:0 *///TODO REMOVE THIS
var dd = require('ES/lib/dd');
var esUtils = require('ES/utils/esUtils');

var getEventClass = function (day_event) {
  return !day_event ? '' : (day_event.type == 'event' ? day_event.sta : day_event.type);
};

var getEventIcon = function (day_event) {
  if (day_event.type == 'flight') {
    return dd.i({className: 'fa fa-plane'});
  } else if (day_event.type == 'ground') {
    return dd.i({className: 'fa fa-car'});
  } else if (day_event.type == 'daily') {
    return dd.i({className: 'fa fa-calendar-o'});
  } else if (day_event.type == 'call') {
    return dd.i({className: 'fa fa-phone'});
  } else if (day_event.type == 'coaching') {
    return dd.i({className: 'fa fa-video-camera'});
  } else if (day_event.type == 'event') {
    return dd.i({className: 'fa fa-circle'});
  }
  return null;
};

var getEventURL = function (event) {
  var url = event.eid > 0 ? '#/events/' + event.eid : null;
  if (url) {
    if (event.type === 'call') {
      url += '/contacts';
    } else if (event.type === 'coaching') {
      url += '/coaching';
    } else if (event.type === 'flight') {
      url += '/travel';
    } else if (event.type === 'ground') {
      url += '/travel';
    }
  }
  return url;
};

let getEventText = function (event) {
  let venue_parts = [];
  if (event.vcty) {
    venue_parts.push(event.vcty);
  }
  if (event.vst) {
    venue_parts.push(event.vst);
  }
  if (event.vcnt) {
    venue_parts.push(event.vcnt);
  }
  let text = esUtils.isBlank(event.desc) ? "" : event.desc;
  if (venue_parts.length > 0) {
    text += " - " + venue_parts.join(', ');
  }
  return text;
};

module.exports = {
  getEventClass: getEventClass,
  getEventIcon: getEventIcon,
  getEventURL: getEventURL,
  getEventText: getEventText,
  getEventHash: function (event) {
    //This is just to help you decide if the event items are talking about the same thing
    return [event.type, getEventURL(event), getEventText(event)].join("-");
  }
};



// WEBPACK FOOTER //
// ./src/components/main_view/calendar_area/CalendarTools.js